import { AppDispatch } from "../redux/store";
import { IRootState } from "../types/redux/IRootStore";

let globalDispatch: AppDispatch;
let globalGetState: () => IRootState;

const setGlobalDispatch = (dispatch: AppDispatch) => globalDispatch = dispatch;
const setGlobalGetState = (getState: () => IRootState) => globalGetState = getState;

export { globalDispatch, globalGetState, setGlobalDispatch, setGlobalGetState };
